import api from '@/helpers/api'

const API_READ=`/api/modules`

export default {
  namespaced:true,
  state: {
    status: '',
    modules:[],
    currUser: {},
    errMessage: '',
  },
  mutations: {
    request(state){
        state.status = 'loading'
    },
    success(state){
        state.status = 'success'
    },
    error(state, {message}){
        state.status = 'error'
        state.errMessage = message
    },
    read(state, {modules}){
        state.modules = [... modules]
    },
  },
  actions: {
    read({commit, state}){

        commit('request')

        return new Promise((resolve, reject) => {
            
            api.request('get', API_READ, {state})
            .then((result) => {
                commit('read',{modules:result.data.data})
                commit('success')
                return resolve(result)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });
    },
  },
  getters : {
    modules: ()=>state => state.modules,
  }
}
